export type Normalized<T, K extends keyof T> = {
  values: Array<T[K]>
  entities: Map<T[K], T>
}

export const createNormalizedEmpty = <T, K extends keyof T>(): Normalized<
  T,
  K
> => ({ values: [], entities: new Map() })

export const normalize = <T, K extends keyof T>(
  source: readonly T[],
  key: K
): Normalized<T, K> =>
  source.reduce<Normalized<T, K>>(
    (accumulator, entity) => ({
      values: [...accumulator.values, entity[key]] as Normalized<
        T,
        K
      >['values'],
      entities: accumulator.entities.set(entity[key], entity),
    }),
    { values: [], entities: new Map() }
  )

export const denormalize = <T, K extends keyof T>(
  values: Normalized<T, K>['values'],
  entities: Normalized<T, K>['entities']
): readonly T[] =>
  values
    .map(key => entities.get(key))
    .filter((value): value is T => value !== undefined)
